import { StageLegacy } from '@silvertours/front-features';
import { Runtime } from '@silvertours/front-entities';

const WidgetPage = () => {
  const { baseImageUrl } = Runtime.useHost();
  return <StageLegacy.WidgetStage baseImageUrl={baseImageUrl} />;
};

export { WidgetPage };
